import { render } from "./ArrowLeft.vue?vue&type=template&id=75348d73&ts=true"
import script from "./ArrowLeft.vue?vue&type=script&lang=ts"
export * from "./ArrowLeft.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__